<template>
  <div class="payment-status">
    <div v-if="paymentRequest" class="payment-status__wrap">
      <div :style="{ 'background-color': backgroundColor }" class="payment-status__title">
        <div
          v-if="!paymentInvoiceLoading"
          :style="{ 'background-color': state.color }"
          class="payment-status__title__logo"
        >
          <div v-if="requestRefreshLoading" class="status-spinner-wrapper">
            <SpinnerButton />
          </div>

          <img v-else :src="state.icon" />
        </div>

        <div class="payment-status__title__logo">
          <PaymentStatusIconSkeleton v-if="paymentInvoiceLoading" />
        </div>

        <div v-if="!paymentInvoiceLoading" class="payment-status__title__text">
          {{ $t(state.text) }}
        </div>
        <PaymentTitleStatusSkeleton
          v-if="paymentInvoiceLoading"
          class="payment-status__title__text"
        ></PaymentTitleStatusSkeleton>
      </div>

      <PaymentStatusDetails v-if="!paymentInvoiceLoading" class="payment-status__details">
        <div class="payment-status__details__title">
          {{ $t('payment_details') }}
        </div>

        <div class="payment-status__details__item">
          <div class="payment-status__details__item__title">
            {{ $t('operation_number') }}
          </div>

          <div class="payment-status__details__item__description">
            {{ paymentRequest.id }}
          </div>
        </div>

        <div class="payment-status__details__item">
          <div class="payment-status__details__item__title">
            {{ $t('payment_date') }}
          </div>

          <div class="payment-status__details__item__description">
            {{ generateDate() }}
          </div>
        </div>

        <div class="payment-status__details__item">
          <div class="payment-status__details__item__title">
            {{ $t('amount') }}
          </div>

          <div class="payment-status__details__item__description">
            {{ amount | formatMoney }}
            {{ paymentRequest.currency }}
          </div>
        </div>
      </PaymentStatusDetails>
      <StyledStatusBlockSkeleton v-if="paymentInvoiceLoading" class="payment-status__details">
        <span class="skeleton__main_title"></span>

        <span class="skeleton__title"></span>
        <span class="skeleton__description"></span>

        <span class="skeleton__title"></span>
        <span class="skeleton__description"></span>

        <span class="skeleton__title"></span>
        <span class="skeleton__description"></span>
      </StyledStatusBlockSkeleton>

      <!-- Will be implemented later , v.1.0 works with iframes only-->
      <!--      <a v-if="isContentInsideIframe">-->
      <!--        <button-->
      <!--          class="btn btn&#45;&#45;med btn&#45;&#45;transparent"-->
      <!--          @click="postMessage('close')"-->
      <!--        >{{ $t('return_to_shop') }}</button>-->
      <!--      </a>-->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import SpinnerButton from '@/components/svg/SpinnerButton';
import postMessageService from '@/mixins/postMessageService';
import styled from 'vue-styled-components';
import iframeDetection from '@/mixins/iframeDetection';
import { setTimeout } from 'timers';

const PaymentStatusDetails = styled.div`
  text-align: left;
  color: var(--on_background);
  &__item {
    color: var(--on_background);
    opacity: 0.8;
  }
`;

const PaymentStatusIconSkeleton = styled.div`
  height: 24px;
  width: 24px;
  animation: shine-avatar 2s infinite ease-out;
  background: #f4f4f4;
  border-radius: 4px;
`;

const PaymentTitleStatusSkeleton = styled.div`
  height: 16px;
  width: 24px;
  animation: shine-avatar 2s infinite ease-out;
  background: #f4f4f4;
  border-radius: 4px;
  width: 180px;
`;

const StyledStatusBlockSkeleton = styled('div', {})`
  .skeleton__title {
    display: block;
    border-radius: 4px;
    height: 16px;
    margin-bottom: 0.5em;
    background-image: linear-gradient(
      90deg,
      #f4f4f4 0px,
      rgba(229, 229, 229, 0.8) 40px,
      #f4f4f4 80px
    );
    animation: shine-avatar 2s infinite ease-out;
    &:nth-child(1) {
      width: 63%;
    }
    &:nth-child(2) {
      width: 57%;
    }
    &:nth-child(3) {
      width: 37%;
    }
  }
  .skeleton__main_title {
    display: block;
    margin-bottom: 1.5em;
    border-radius: 4px;
    height: 16px;
    width: 26%;
    background-image: linear-gradient(
      90deg,
      #f4f4f4 0px,
      rgba(229, 229, 229, 0.8) 40px,
      #f4f4f4 80px
    );
    animation: shine-avatar 2s infinite ease-out;
  }
  .skeleton__description {
    display: block;
    margin-bottom: 1em;
    border-radius: 4px;
    height: 12px;
    background-image: linear-gradient(
      90deg,
      #f4f4f4 0px,
      rgba(229, 229, 229, 0.8) 40px,
      #f4f4f4 80px
    );
    animation: shine-avatar 2s infinite ease-out;
    &:nth-child(1) {
      width: 63%;
    }
    &:nth-child(2) {
      width: 57%;
    }
    &:nth-child(4) {
      width: 37%;
    }
    &:nth-child(5) {
      width: 37%;
    }
  }
  background-size: 600px;

  @keyframes shine-lines {
    0% {
      background-position: -100px;
    }
    40%,
    100% {
      background-position: 140px;
    }
  }
  @keyframes shine-avatar {
    0% {
      background-position: -32px;
    }
    40%,
    100% {
      background-position: 208px;
    }
  }
`;

export default {
  name: 'PaymentStatusComponent',

  components: {
    SpinnerButton,
    PaymentStatusDetails,
    StyledStatusBlockSkeleton,
    PaymentStatusIconSkeleton,
    PaymentTitleStatusSkeleton,
  },

  mixins: [postMessageService, iframeDetection],

  beforeRouteEnter(to, from, next) {
    next();
  },

  beforeDestroy() {
    clearInterval(this.checkStatusInterval);
  },

  async created() {
    this.isContentInsideIframe = this.checkThatAppInsideIframe();

    this.SET_CURRENT_STEP(3);
    try {
      this.paymentInvoiceLoading = true;
      const { id } = this.$route.params || false;
      this.paymentRequestId = id;
      this.requestRefreshLoading = true;

      if (!id) {
        throw new Error('No passed id');
      }
      clearInterval(this.checkStatusInterval);
      this.checkPaymentStatus();

      /**
       * Set interval that will check status of payment
       */
      this.checkStatusInterval = setInterval(() => {
        this.checkPaymentStatus();
      }, this.delay);
    } catch (e) {
      this.setGlobalError(e);
    }
  },

  data() {
    return {
      paymentInvoiceLoading: true,
      requestRefreshLoading: true,

      checkStatusInterval: null,
      delay: 5000,

      paymentRequestId: false,
    };
  },

  computed: {
    ...mapState(['paymentInvoiceData', 'paymentInvoiceStatuses']),
    paymentRequest() {
      return this.paymentInvoiceData ? this.paymentInvoiceData.data || this.paymentInvoiceData : {};
    },

    amount() {
      return ['partially_processed', 'processed'].includes((this.paymentInvoice || {}).status) &&
        this.paymentInvoice.processed_amount !== null
        ? this.paymentInvoice.processed_amount
        : this.paymentInvoice.amount;
    },

    state() {
      let currentStatusData = {};
      const currentStatus = this.paymentRequest.status;
      if (this.paymentInvoiceStatuses[currentStatus]) {
        currentStatusData = this.paymentInvoiceStatuses[currentStatus];
      }

      return currentStatusData;
    },

    backgroundColor() {
      if (this.screenSize.width < 421) {
        return this.state.color;
      } else {
        return 'transparent !important';
      }
    },

    paymentInvoice() {
      return this.paymentInvoiceData ? this.paymentInvoiceData.data || this.paymentInvoiceData : {};
    },

    hasReturnUrl() {
      return this.paymentInvoice.has_return_url;
    },
  },

  methods: {
    ...mapActions(['getPaymentInvoiceById', 'setGlobalError']),
    ...mapMutations(['SET_CURRENT_STEP']),

    generateDate() {
      console.log('date created', this.paymentRequest.created);
      let date = this.paymentRequest.created
        ? new Date(this.paymentRequest.created * 1000)
        : new Date();

      function toFixed(arr) {
        //  TODO: ?? refactor ??
        return arr.map(num => (num < 10 ? `0${num}` : num)); // eslint-disable-line
      }

      const dmy = [date.getDate(), date.getMonth() + 1, date.getFullYear()];
      const time = [date.getHours(), date.getMinutes()];

      return `${toFixed(dmy).join('.')} ${toFixed(time).join(':')}`;
    },

    async checkPaymentStatus() {
      if (!!Object.keys(this.state).length) {
        this.requestRefreshLoading = false;
        this.paymentInvoiceLoading = false;
      }

      if (this.state.isFinal) {
        clearInterval(this.checkStatusInterval);
        setTimeout(() => {
          this.redirectToMerchantSite();
        }, 3000);
      } else {
        console.log('Not a final status', this.state);
        try {
          this.requestRefreshLoading = true;
          await this.getPaymentInvoiceById(this.paymentRequestId);
        } catch (e) {
          console.error('Got some', e);
        } finally {
          this.requestRefreshLoading = false;
        }
      }
    },

    redirectToMerchantSite() {
      if (!this.hasReturnUrl) {
        return;
      }

      location.replace(`/return?id=${this.paymentInvoice.id}&force=true`);
    },
  },
};
</script>
